export default {
  data: () => ({
    cashPaymentTypes: ["cash_on_delivery"],
    thirdPartyPaymentTypes: ["linepay", "ecpay"],
  }),
};
